import actions from './actions'
import feedbackCollect from './metaData/feedbackCollect'
export default {
  state: feedbackCollect,
  actions
}
